"use client";

import {
  Container,
  Title,
  Text,
  Button,
  Stack,
  Box,
  Card,
  Group,
  Badge,
  SimpleGrid,
  ThemeIcon,
  List,
  Alert,
  Divider,
  ColorSwatch,
  Paper,
  Grid,
  Table,
} from "@mantine/core";
import {
  IconPalette,
  IconClock,
  IconCheck,
  IconArrowRight,
  IconPhoto,
  IconShirt,
  IconSparkles,
  IconUsers,
  IconStar,
  IconEye,
  IconHeart,
  IconUpload,
  IconShield,
  IconDownload,
  IconDroplet,
  IconRefresh,
  IconColorSwatch,
  IconFlower,
  IconSun,
  IconLeaf,
  IconSnowflake,
  IconDropletFilled,
  IconSunrise,
  IconTie,
  IconShirtFilled,
  IconCamera,
  IconFileDownload,
  IconShare,
} from "@tabler/icons-react";
import { Link } from "@/i18n/navigation";
import { PRICING } from "@/constants/pricing";
import UnifiedUpsell from "@/components/UnifiedUpsell";
import { useTranslations } from "next-intl";

export default function ChromaValueBrightnessContent() {
  const t = useTranslations("chromaValueBrightness");
  return (
    <Container size="lg" py="xl">
      <Stack gap="xl">
        {/* Hero Section */}
        <Box ta="center">
          <Title order={1} size="h1" mb="md">
            {t("title")}
          </Title>
          <Text size="lg" c="dimmed" maw={600} mx="auto" mb="xl">
            {t("subtitle")}
          </Text>
        </Box>

        {/* Chroma Explanation */}
        <Card withBorder p="xl" radius="md">
          <Title order={2} mb="md">
            {t("sectionTitle")}
          </Title>
          <Text mb="lg">
            {t("chromaIntro")}
          </Text>
          <SimpleGrid cols={{ base: 1, md: 2 }} spacing="xl">
            <Box>
              <Title order={3} size="h4" mb="md" c="violet">
                {t("highChromaTitle")}
              </Title>
              <List size="sm" spacing="xs">
                <List.Item>{t("highChromaBright")}</List.Item>
                <List.Item>{t("highChromaSaturation")}</List.Item>
                <List.Item>{t("highChromaIntense")}</List.Item>
                <List.Item>{t("highChromaBest")}</List.Item>
              </List>
            </Box>
            <Box>
              <Title order={3} size="h4" mb="md" c="gray">
                {t("lowChromaTitle")}
              </Title>
              <List size="sm" spacing="xs">
                <List.Item>{t("lowChromaMuted")}</List.Item>
                <List.Item>{t("lowChromaSaturation")}</List.Item>
                <List.Item>{t("lowChromaDusty")}</List.Item>
                <List.Item>{t("lowChromaBest")}</List.Item>
              </List>
            </Box>
          </SimpleGrid>
        </Card>

        {/* CTA */}
        <Box ta="center" py="xl">
          <Title order={2} mb="md">
            {t("ctaTitle")}
          </Title>
          <Text size="lg" c="dimmed" mb="xl">
            {t("ctaDescription")}
          </Text>
          <Group justify="center" gap="md">
            <Button
              size="xl"
              component={Link}
              href="/color-analysis-quiz"
              color="violet"
              rightSection={<IconPalette size={20} />}
            >
              {t("quizButton")}
            </Button>
            <Button
              size="xl"
              variant="outline"
              component={Link}
              href="/ai-color-analysis"
              color="violet"
              rightSection={<IconPhoto size={20} />}
            >
              {t("photoAnalysisButton")}
            </Button>
          </Group>
        </Box>
      </Stack>
    </Container>
  );
}
